// extracted by mini-css-extract-plugin
module.exports = {"error_message":"FaqContent_error_message__2cAqe"};